import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import admin from '@/components/admin'
import collection from '@/components/collection'
import gallery from '@/components/gallery'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/admin/:id',
      name: 'admin',
      component: admin
    },    
    {
      path: '/collection/:id',
      name: 'collection',
      component: collection
    },
    {
      path: '/gallery/:id',
      name: 'gallery',
      component: gallery
    }    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js